import { Component, Input, inject } from '@angular/core';

import { SideMenuService } from '@widgets/navigation/side-menu/side-menu.service';

@Component({
  selector: 'app-side-menu-button',
  templateUrl: './side-menu-button.component.html',
  styleUrls: ['./side-menu-button.component.scss'],
  standalone: false,
})
export class SideMenuButtonComponent {
  @Input() title = '';
  @Input() icon = '';
  @Input() link: string | undefined;
  @Input() exact: boolean = true;

  protected readonly sideMenuService = inject(SideMenuService);
}
